import React, { useContext, useEffect, useState } from "react";
import { PageComponent } from "../../components/PageComponent";
import { OpportunitySearchComponent } from "../../components/OpportunitySearchComponent/OpportunitySearchComponent";
import SignInModal from "../../components/AuthenticationModals/SignInModal";
import { ModalPageNames } from "../../consts";
import { EnvironmentContext } from "../../contexts/environment/environmentContext";
import SignedOutModal from "../../components/SignedOutModal";
import { useLocation } from "react-router-dom";
import { ROUTE_PATHS } from "../../consts/RoutePaths";

export function DefaultLandingPage() {
   const [modalShow, setModalShow] = useState<boolean>(false);
   const [signedOutModalShow, setSignedOutModalShow] = useState<boolean>(false);

   const { environmentConfig } = useContext(EnvironmentContext);
   const { pathname } = useLocation();
   const [confirmedAptDetails, setConfirmedAptDetails] = useState<
       string | undefined
   >(undefined);

   useEffect(() => {
      const confirmedAptDetailValue: string | null =
          sessionStorage.getItem("confirmedAppointmentDetails") || null;
      if (confirmedAptDetailValue) {
         setConfirmedAptDetails(JSON.parse(confirmedAptDetailValue));
         setModalShow(true);
         sessionStorage.removeItem("confirmedAppointmentDetails");
      } else if (pathname.includes(ROUTE_PATHS.SIGNED_OUT)) {
         setSignedOutModalShow(true);
      }
   }, []);
   return (
       <PageComponent
           name={"DonorLandingPage"}
           title={`${environmentConfig?.pageTitle} – Home (Appointment Search)`}
           description={"Donor Landing Page"}
       >
          <OpportunitySearchComponent />
          <SignedOutModal
              show={signedOutModalShow}
              setModalShow={setSignedOutModalShow}
              message={"Signed Out"}/>
          <SignInModal
              show={modalShow}
              setModalShow={setModalShow}
              pageNameSent={ModalPageNames.APPOINTMENT_CONFIRMATION}
              confirmedAptDetails={confirmedAptDetails}
          />
       </PageComponent>
   );
}
